import { useRef, useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function LineWipeTransition({ isActive, onMidway }) {
  const [phase, setPhase] = useState("enter");
  const audioRef = useRef(null);

  useEffect(() => {
    if (isActive) {
      // Play magic spell sound
      audioRef.current?.play().catch(() => {});
      const timer = setTimeout(() => {
        setPhase("exit");
        onMidway?.();
      }, 700);
      return () => clearTimeout(timer);
    }
  }, [isActive]);

  return (
    <AnimatePresence>
      {isActive && (
        <motion.div
          className="fixed inset-0 z-[9999] bg-transparent flex items-center justify-center pointer-events-none"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-gradient-to-b from-indigo-900 via-purple-800 to-pink-600"
            style={{
              height: "100vh",
              width: "2px",
              transformOrigin: "center",
            }}
            initial={{ clipPath: "inset(50% 0 50% 0)" }}
            animate={
              phase === "enter"
                ? { clipPath: "inset(0% 0 0% 0)" }
                : { width: "100vw", clipPath: "inset(0% 0 0% 0)" }
            }
            transition={{ duration: 1, ease: "easeInOut" }}
          />
        </motion.div>
      )}

      {/* 🧙‍♂️ Magical reveal sound */}
      <audio ref={audioRef} src="/audio/magic-spell.mp3" preload="auto" />
    </AnimatePresence>
  );
}
